var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon20StarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-20-star_half",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 20,
    height: 20,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M12.581,15h-.017a.389.389,0,0,1-.2-.055L8,12.316,3.66,14.944a.384.384,0,0,1-.2.055H3.443a.376.376,0,0,1-.23-.079l-.2-.119a.4.4,0,0,1-.152-.418L4.011,9.473.142,6.205a.385.385,0,0,1-.12-.426l.088-.2a.39.39,0,0,1,.351-.276l5.1-.4L7.513.253A.4.4,0,0,1,7.891,0h.221a.392.392,0,0,1,.367.253L10.465,4.9l5.1.4a.391.391,0,0,1,.351.276l.064.2a.383.383,0,0,1-.112.418L11.989,9.473l1.148,4.911a.4.4,0,0,1-.151.418l-.176.119A.376.376,0,0,1,12.581,15ZM8,2.693H8v8l3.288,1.982-.894-3.695,2.928-2.471-3.838-.3Z",
    transform: "translate(2 2)",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20StarHalf);
export default __webpack_public_path__ + "static/media/icon-20-star_half.b7ff5c42b9685669e30da9c7acd99bac.svg";
export { ForwardRef as ReactComponent };